import { render, staticRenderFns } from "./image.vue?vue&type=template&id=611de19a&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=611de19a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611de19a",
  null
  
)

export default component.exports